import React, { useState } from "react";
import { useLoadScript,GoogleMap, InfoWindow, Marker } from "@react-google-maps/api";
import { arrayService } from '../services/array';
import { userService } from '../services/user';
import _ from 'lodash';
import '../assets/styles/Map.scss';
import markerIcon from '../assets/images/homepage-map-icon.png';
import default_avatar from '../assets/images/avatar-default.png';
import location_pin_outline_icon from '../assets/images/location-pin-outline-icon.png';
import closeIcon from '../assets/images/map-marker-close-icon.png';

function Map(data) {
    const { isLoaded } = useLoadScript({
      googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY
    });

  const [activeMarker, setActiveMarker] = useState(null);

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  const handleOnLoad = (map) => {
    const bounds = new window.google.maps.LatLngBounds();

    if(_.has(data, 'location_friendly_id')){
      data.results.forEach(function(item) {
        let location = arrayService.findElementByProperty(item.locations, 'friendly_id', data.location_friendly_id);
        bounds.extend({lat: parseFloat(location.lat), lng: parseFloat(location.long)});
      });
    }else{
      data.results.forEach(item => bounds.extend({lat: item.location.lat, lng: item.location.long}));
    }

    if(data.results.length > 1){
      map.fitBounds(bounds);
    }else{
      map.setCenter(bounds.getCenter());
      map.setZoom(16);
    }
  };

  const containerStyle = {
    position: 'relative',
    width: '100%',
    height: '100%'
  }

  return isLoaded ? (
    <GoogleMap
      onLoad={handleOnLoad}
      onClick={() => setActiveMarker(null)}
      mapContainerStyle={containerStyle}
    >
      {data.results.map((item, index) => (
        <Marker
          key={`map-marker-${index}`}
          position={{ lat: (_.has(data, 'location_friendly_id') ? parseFloat(arrayService.findElementByProperty(item.locations, 'friendly_id', data.location_friendly_id).lat) : item.location.lat ), lng: (_.has(data, 'location_friendly_id') ? parseFloat(arrayService.findElementByProperty(item.locations, 'friendly_id', data.location_friendly_id).long) : item.location.long) }}
          onClick={() => handleActiveMarker(`map-marker-${index}`)}
          icon={{url: markerIcon}}
        >
          {activeMarker === `map-marker-${index}` ? (
            <InfoWindow onCloseClick={() => setActiveMarker(null)}>
              <div className={`marker-container ${data.parentName}`}>
                <button className="btn close-marker-btn" onClick={() => setActiveMarker(null)} title="Close">
                  <img src={closeIcon}/>
                </button>
                <div className="marker-info-container text-center">
                  <div className="profile-pic">
                    <img src={`${item.avatar ? (item.avatar.url.thumb.url) : default_avatar}`} onError={(e) => { e.target.src = default_avatar }} alt="profile-pic"/>
                  </div>
                  <div className="marker-info-name">{item.name}</div>
                  <div className="marker-info-specialty">{item.specialties[0].name}</div>
                  <a className="marker-info-location" href={`/search-book/clinic/${item.location.friendly_id}`} target="_blank" rel="noopener noreferrer">
                    <img className="location-pin-outline-icon" src={location_pin_outline_icon} alt='location-pin-icon' />
                    {item.location.name}
                  </a>
                </div>
                {data.parentName === "ResultMapView" && (
                  <div className="button-group-2">
                    {userService.getUser() && (
                      <a className="btn btn-call" href={`tel:${item.phone_number}`}>Call</a>
                    )}
                    <a className="btn btn-view" href={`/search-book/professional-profile/${item.friendly_id}/${item.location.friendly_id}`} target="_blank" rel="noopener noreferrer">View</a>
                  </div>
                )}
              </div>
            </InfoWindow>
          ) : null}
        </Marker>
      ))}
    </GoogleMap>
  ) : <div>loading</div>;
}

export default Map;
